<template>
  <div>
    <logged-in-header />
    <transactions />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import transactions from "../components/transaction/Transactions";

export default {
  components: {
    loggedInHeader,
    transactions
  }
};
</script>
